if (__PRODUCTION__) {
  const host = window.location.host.split(".");
  host.shift();
  __webpack_public_path__ = `https://cdn.${host.join(".")}/`;
} else {
  __webpack_public_path__ = "/";
}
